module["exports"] = [
  "?#? #?#"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/fr_CA/address/postcode.js
 ** module id = 707
 ** module chunks = 0
 **/